import { AxiosInstance } from 'axios';
import TicketRepositoryInterface, {
  TicketInterface,
  TicketScoreRequestInterface,
} from '@/services/QA/ticket/interfaces';

export default class TicketRepository implements TicketRepositoryInterface {
  private readonly axios: AxiosInstance;

  constructor(axios: AxiosInstance) {
    this.axios = axios;
  }

  public async getAllTickets(page: number, reviewed: boolean): Promise<[TicketInterface[], number]> {
    const res = await this.axios.get(`/qa-controller/tickets?page=${page}&reviewed=${reviewed}`);

    return res.data;
  }

  public async getUnreviewedTicket(ticketId: number): Promise<TicketInterface> {
    const res = await this.axios.get(`/qa-controller/tickets/unreviewed/${ticketId}`);

    return res.data;
  }

  public async reviewTicket(
    ticketId: number,
    agents: string[],
    scores: TicketScoreRequestInterface,
    tags: number[],
    sendStats: boolean = true,
  ): Promise<void> {
    await this.axios.patch(`/qa-controller/tickets/${ticketId}`, { agents, sendStats, data: { scores, tags } });
  }

  public async getOneById(ticketId: number): Promise<TicketInterface> {
    const res = await this.axios.get(`/qa-controller/tickets/${ticketId}`);

    return res.data;
  }

  public async searchTickets(search: string, page: number): Promise<void> {
    await this.axios.get(
      `/qa-controller/tickets/search/${search}?page=${page}`,
    );
  }

}
